export default "__VITE_ASSET__Y5g99Y16__"